// Central definition of cross-portal target application keys used when creating exchange tokens
// These keys must align with the backend allowlist for create-exchange-token
// Extend with metadata (displayName, envVar, etc.) later as needed.

export const TARGET_APPS = Object.freeze({
	ADMIN: 'admin', // (future use if reverse flow initiated from other portals)
	RISK: 'risk',
	DASHBOARD: 'dashboard',
	CONNECTOR: 'connector',
	ANALYTICS: 'analytics',
	NOTICES: 'notices',
	PREFPAGES: 'prefpages',
	SITE_SCANNER: 'site-scanner'
})
